// Tie-In - Triage Module Theme
export const t = {
  colors: {
    bg:           '#0D0F0F',
    bgElevated:   '#161A1A',
    bgPanel:      '#1C2020',
    bgInput:      '#222828',
    bgHover:      '#1F2424',
    border:       '#2A3030',
    borderStrong: '#3A4444',
    borderFocus:  '#FF6B2B',
    textPrimary:  '#F0F4F4',
    textSecondary:'#8A9A9A',
    textMuted:    '#4A5A5A',
    accent:       '#FF6B2B',
    accentDim:    '#CC5522',
    accentGlow:   'rgba(255, 107, 43, 0.15)',
    success:      '#2ECC8A',
    successDim:   'rgba(46, 204, 138, 0.15)',
    warning:      '#F5C842',
    warningDim:   'rgba(245, 200, 66, 0.15)',
    danger:       '#E84040',
    dangerDim:    'rgba(232, 64, 64, 0.15)',
    leak:         '#E84040',
    leakDim:      'rgba(232, 64, 64, 0.12)',
    leakBorder:   'rgba(232, 64, 64, 0.35)',
    eod:          '#F5C842',
    eodDim:       'rgba(245, 200, 66, 0.12)',
    eodBorder:    'rgba(245, 200, 66, 0.35)',
    thisWeek:     '#7EC8E3',
    thisWeekDim:  'rgba(126, 200, 227, 0.12)',
    thisWeekBorder:'rgba(126, 200, 227, 0.35)',
    expense:      '#2ECC8A',
    expenseDim:   'rgba(46, 204, 138, 0.12)',
    expenseBorder:'rgba(46, 204, 138, 0.35)',
    low:          '#4A5A5A',
    lowDim:       'rgba(74, 90, 90, 0.20)',
    lowBorder:    'rgba(74, 90, 90, 0.35)',
  },
  fonts: {
    display: "'Barlow Condensed', sans-serif",
    body:    "'IBM Plex Sans', sans-serif",
    mono:    "'IBM Plex Mono', monospace",
  },
  radii: {
    sm:   '3px',
    md:   '6px',
    lg:   '10px',
    pill: '999px',
  },
  spacing: {
    xs:  '4px',
    sm:  '8px',
    md:  '16px',
    lg:  '24px',
    xl:  '32px',
    xxl: '48px',
  },
  tap: { min: '48px' },
  transitions: {
    fast:   'all 0.12s ease',
    normal: 'all 0.2s ease',
  },
};

export const TIER_META = {
  LEAK: {
    label:    'LEAK',
    color:    t.colors.leak,
    dim:      t.colors.leakDim,
    border:   t.colors.leakBorder,
    textColor:'#E84040',
  },
  EOD: {
    label:    'EOD',
    color:    t.colors.eod,
    dim:      t.colors.eodDim,
    border:   t.colors.eodBorder,
    textColor:'#F5C842',
  },
  THIS_WEEK: {
    label:    'This Week',
    color:    t.colors.thisWeek,
    dim:      t.colors.thisWeekDim,
    border:   t.colors.thisWeekBorder,
    textColor:'#7EC8E3',
  },
  EXPENSE: {
    label:    'Expense',
    color:    t.colors.expense,
    dim:      t.colors.expenseDim,
    border:   t.colors.expenseBorder,
    textColor:'#2ECC8A',
  },
  LOW: {
    label:    'Low',
    color:    t.colors.low,
    dim:      t.colors.lowDim,
    border:   t.colors.lowBorder,
    textColor:'#8A9A9A',
  },
};

export default t;
